import request from '@/utils/request'

/**
 * 后端生成私有空间文件的临时下载/预览 URL
 * @param {{ fileKey: string, expires?: number | null, inline?: boolean }} data - expires 可选；inline 为 true 时建议签出 Content-Disposition:inline，便于新标签预览而非下载
 */
export const getPrivateDownloadUrl = (data) => {
  return request({
    method: 'post',
    url: '/merchant/v2/qiniu/get_private_download_url',
    data,
  })
}

/**
 * 后端签发七牛上传凭证（勿在前端存放 AK/SK）
 * 成功时 data：{ token, expires_in, bucket, key }，可选 domain
 * @param {{ key?: string }} params - 与 putPolicy 一致的 object key
 */
export const getUploadToken = (params) => {
  return request({
    method: 'get',
    url: '/merchant/v2/qiniu/get_upload_token',
    params: params || {},
  })
}
